import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAllCompetetionTrends,
  getAllPPBTrends,
  getAllPPCTrends,
  getAllTimeTrends,
} from "./analytics.thunk";

const init_state = {
  competetionTrends: {},
  timeTrends: {},
  ppcTrends: {},
  ppbTrends: {},
};

export const fetchAllCompetetionTrends = createAsyncThunk(
  "fetchAllCompetetionTrends",
  getAllCompetetionTrends
);

export const fetchAllTimeTrends = createAsyncThunk(
  "fetchAllTimeTrends",
  getAllTimeTrends
);

export const fetchPPCTrends = createAsyncThunk(
  "fetchAllPPCTrends",
  getAllPPCTrends
);

export const fetchPPBTrends = createAsyncThunk(
  "fetchAllPPBTrends",
  getAllPPBTrends
);

const analyticsSlice = createSlice({
  name: "Analytics",
  initialState: init_state,
  reducers: {
    setCompetitionTrens: (state, action) => {
      state.competetionTrends = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCompetetionTrends.pending, (state, action) => {
        return state;
      })
      .addCase(fetchAllCompetetionTrends.fulfilled, (state, action) => {
        state.competetionTrends = action.payload;
      })
      .addCase(fetchAllCompetetionTrends.rejected, (state, action) => {
        return state;
      })
      .addCase(fetchAllTimeTrends.pending, (state, action) => {
        return state;
      })
      .addCase(fetchAllTimeTrends.fulfilled, (state, action) => {
        state.timeTrends = action.payload;
      })
      .addCase(fetchAllTimeTrends.rejected, (state, action) => {
        return state;
      })
      .addCase(fetchPPCTrends.pending, (state, action) => {
        return state;
      })
      .addCase(fetchPPCTrends.fulfilled, (state, action) => {
        state.ppcTrends = action.payload;
      })
      .addCase(fetchPPCTrends.rejected, (state, action) => {
        return state;
      })
      .addCase(fetchPPBTrends.pending, (state, action) => {
        return state;
      })
      .addCase(fetchPPBTrends.fulfilled, (state, action) => {
        state.ppbTrends = action.payload;
      })
      .addCase(fetchPPBTrends.rejected, (state, action) => {
        return state;
      });
  },
});

export const { setCompetitionTrens } = analyticsSlice.actions;
export default analyticsSlice.reducer;
